import React from 'react';
import { ITags } from 'types';
import OutsideFormInput from 'components/Input/OutsideFormInput';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Items.module.scss';

interface IItems {
	changeTags: (value: string, item: number, languageId: string) => void;
	deleteTag: (item: number) => void;
	tag: ITags;
	isShowItems: boolean;
	isShowDeleteIcon: boolean;
	isShowAdditionalTags: boolean;
}

const Items: React.FC<IItems> = ({
	changeTags,
	deleteTag,
	tag,
	isShowItems,
	isShowDeleteIcon,
	isShowAdditionalTags,
}) => {
	const containerClasses = classNames(style.container, { [style.showContainer]: isShowItems && tag.tags.length });
	const deleteIconClasses = classNames(style.deleteIcon, {
		[style.showDeleteIcon]: isShowDeleteIcon,
	});

	return (
		<div className={containerClasses}>
			{tag.tags.map((el, i) => {
				const inputWrapperClasses = classNames(style.inputWrapper, {
					[style.hideAdditionalTag]: i > 2 && !isShowAdditionalTags,
				});

				return (
					<div className={inputWrapperClasses} key={tag.languageId + String(i)}>
						<OutsideFormInput
							testId="Items"
							className={style.input}
							name={tag.languageId + String(i)}
							label="tagLabel"
							placeholder="enterTagPlaceholder"
							translationOptions={{ counterValue: String(i + 1) }}
							errorMessage="enterTag"
							onChange={(value) => changeTags(value, i, tag.languageId)}
							value={el}
						/>
						<svg className={deleteIconClasses} onClick={() => deleteTag(i)}>
							<use xlinkHref={`${breadcrumbs}#close`} />
						</svg>
					</div>
				);
			})}
		</div>
	);
};

export default React.memo(Items);
